/* ============================================================
   Where the Cognito tokens live on the web: localStorage. There is no keychain
   in a browser; this is the standard SPA trade (Todoist, Linear, Notion all
   keep a session token the page can read), and the threat it accepts is a
   script running on OUR origin — which is why the app loads no third-party
   scripts and will ship a Content-Security-Policy with the hosting. The
   tokens are short-lived (60 min) and the refresh token is revoked on sign-out
   (client-core AuthContext).

   A separate module from storage.ts although it is the same store, so the
   two jobs stay distinguishable and a later move (e.g. to a BFF cookie)
   touches one file.
   ============================================================ */
import type { KeyValueStorage } from '@habishine/client-core';

export const tokenStorage: KeyValueStorage = {
  async getItem(key) {
    return localStorage.getItem(key);
  },
  async setItem(key, value) {
    localStorage.setItem(key, value);
  },
  async removeItem(key) {
    localStorage.removeItem(key);
  },
};
